import { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';

export default function useExternalScripts( url ){
  const params = useParams();
  // eslint-disable-next-line no-unused-vars
  const location = useLocation();
  useEffect(() => {
    const script = document.createElement("script");

    script.type = 'text/javascript';
    script.src = url
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.id, window.location.href]);
};